<template>
    <div class="tenant-main-page" ref="formContainer">
        <div class="action d-flex position-absolute">
            <img @click="this.deleteConfirmShow = true;" class="button-action" src="/images/icons/button-delete.svg">
            <img  v-if="edited" @click="undo(infoTenant.id)" class="button-action margin-button" src="/images/icons/button-undo.svg">
            <img  v-if="edited" @click="saveTenant" class="button-action margin-button"
                 src="/images/icons/button-update.svg">
        </div>
        <div class="main-content">
            <Form :validation-schema="schema" v-slot="{ errors }" @submit="updateTenant">
                <div class="info-tenant col-md-12 d-flex position-relative">
                    <div class="col-md-8">
                        <div class="info-text-tenant col-md-12 d-flex">
                            <div class="col-md-4 custom-width news-form__input">
                                <label class="news-form__title label-field">
                                    Select SECTION
                                </label>
                                <a-select
                                    v-model:value="infoTenant.section_id"
                                    show-search
                                    style="width: 100%"
                                    option-filter-prop="children"
                                    :options="listSection"
                                    :filter-option="filterOption"
                                    @change="handleChangeSection"
                                    :disabled="true"
                                >
                                    <a-select-option v-for="item in listSection" :key="item.value"
                                                     :value="item.value"
                                                     :label="item.label"
                                    >
                                        {{ item.label }}
                                    </a-select-option>
                                </a-select>
                            </div>
                            <div class="col-md-4 custom-width news-form__input">
                                <Field name="Category" class="form-control"
                                       :class="{ 'is-invalid': errors.Category }" v-model="infoTenant.category_id">
                                <label class="news-form__title label-field" :class="errors.Category ? 'news-form__title--error' : ''">
                                    Select CATEGORY
                                </label>
                                <a-select
                                    v-model:value="infoTenant.category_id"
                                    show-search
                                    style="width: 100%"
                                    option-filter-prop="children"
                                    :options="listCategory"
                                    :filter-option="filterOptionCategory"
                                    @change="handleChangeCategory"
                                    :status="errors.Category ? 'error' : ''"
                                >
                                    <a-select-option v-for="item in listCategory" :key="item.value"
                                                     :value="item.value"
                                                     :label="item.label"
                                                     name="category"
                                    >
                                        {{ item.label }}
                                    </a-select-option>
                                </a-select>
                                    <div class="invalid-feedback d-inline-block">{{ errors.Category }}</div>
                                </Field>
                            </div>
                            <div class="col-md-4 custom-width news-form__input">
                                <Field name="Floor" class="form-control"
                                       :class="{ 'is-invalid': errorFloor }" v-model="listFloorSelected">
                                    <label class="news-form__title label-field"
                                           :class="errorFloor ? 'news-form__title--error' : ''">
                                        FLOOR NUMBER
                                    </label>
                                    <a-select
                                        v-model:value="listFloorSelected"
                                        :options="listFloor"
                                        mode="multiple"
                                        :size="'middle'"
                                        placeholder="Select FLOOR"
                                        style="width: 100%"
                                        @change="handleChangeFloor"
                                        :status="errorFloor ? 'error' : ''"
                                    ></a-select>
                                    <div class="invalid-feedback d-inline-block">{{ errorFloorMessage }}</div>
                                </Field>
                            </div>
                        </div>
                        <div class="info-text-tenant col-md-12 d-flex">
                            <div class="col-md-4 custom-width news-form__input">
                                <label class="news-form__title label-field"
                                       :class="errors.Name ? 'news-form__title--error' : ''">
                                    Input TENANT NAME
                                </label>
                                <a-input :maxlength="255" @keydown.enter.prevent @change="edited = true" :status="errors.Name ? 'error' : ''" v-model:value="infoTenant.name"/>
                                <Field name="Name" type="hidden" class="form-control"
                                       :class="{ 'is-invalid': errors.Name }"
                                       v-model="infoTenant.name"
                                />
                                <div class="invalid-feedback">{{ errors.Name }}</div>
                            </div>
                            <div class="col-md-4 custom-width custom-margin news-form__input">
                                <label class="news-form__title">
                                    Input HOTLINE
                                </label>
                                <a-input :maxlength="255" @keydown.enter.prevent @change="edited = true" v-model:value="infoTenant.hot_line"/>
                            </div>
                            <div class="col-md-4 custom-width position-relative">
                                <a-checkbox @change="changeLsPoint" v-model:checked="lsPointChecked">LS. POINT
                                </a-checkbox>
                                <a-checkbox @change="changeLotteVoucher"  v-model:checked="lotteVoucher" style="margin-left: 100px;">Lotte Voucher
                                </a-checkbox>
                            </div>
                        </div>
                    </div>

                    <div class="info-image-tenant d-flex position-absolute">
                        <div class="tenant-logo news-form__thumb-input">
                            <Field v-model="infoTenant.tenant_logo" name="TenantLogo" class="form-control"
                                   :class="{ 'is-invalid': errors.TenantLogo }">
                                <label :class="errors.TenantLogo ? 'news-form__title--error' : ''"
                                       class="news-form__title label-field">TENANT
                                    LOGO</label>
                                <custom-upload-tenant
                                    v-model="infoTenant.tenant_logo"
                                    v-model:base64-string="base64Logo"
                                    :class="errors.TenantLogo ? 'news-form__upload-thumb--error' : ''"
                                    class="news-form__upload-thumb"
                                    name="TenantLogo"
                                    v-model:mess-error-tenant-logo="messErrorTenantLogo"
                                    v-model:upload-tenant-logo="uploadTenantImageLogo"
                                    v-model:is-change-tenant-logo="isChangeTenantImageLogo"
                                    v-model:open="open"
                                    @change="edited = true"
                                >
                                    <div v-if="!base64Logo">
                                        <img src="/images/icons/blank-image.svg">
                                        <div class="news-form__thumb-btn">UPLOAD</div>
                                    </div>
                                    <div v-else class="news-form__thumb-preview">
                                        <img style="width: 100%;" v-if="isChangeTenantImageLogo" :src="base64Logo"
                                             alt="Tenant LOGO"/>
                                        <img style="width: 100%;" v-else :src="'/storage/' + base64Logo"
                                             alt="Tenant LOGO"/>
                                    </div>
                                </custom-upload-tenant>
                                <div class="invalid-feedback custom-required-logo d-inline-block">{{
                                        errors.TenantLogo
                                    }}
                                </div>
                                <div
                                    class="text-danger"
                                    v-if="messErrorTenantLogo"
                                >
                                    {{ messErrorTenantLogo }}
                                </div>
                            </Field>
                        </div>
                        <div class="custom-margin news-form__thumb-input">
                            <Field v-model="infoTenant.tenant_image" name="TenantImage" class="form-control">
                                <label class="news-form__title">TENANT IMAGE</label>
                                <custom-upload-tenant
                                    v-model="infoTenant.tenant_image"
                                    v-model:base64-string-image="base64Image"
                                    class="news-form__upload-thumb"
                                    name="TenantImage"
                                    v-model:mess-error-tenant-image="messErrorImage"
                                    v-model:upload-tenant-image="uploadTenantImage"
                                    v-model:is-change-tenant-image="isChangeTenantImage"
                                    v-model:open="open"
                                    @change="changeUploadImage"
                                >
                                    <div v-if="!base64Image">
                                        <img src="/images/icons/blank-image.svg">
                                        <div class="news-form__thumb-btn">UPLOAD</div>
                                    </div>
                                    <div v-else class="news-form__thumb-preview">
                                        <img style="width: 100%;" v-if="isChangeTenantImage" :src="base64Image"
                                             alt="Tenant IMAGE"/>
                                        <img style="width: 100%;" v-else :src="'/storage/' + base64Image"
                                             alt="Tenant IMAGE"/>
                                    </div>
                                </custom-upload-tenant>
                                <p v-if="base64Image" class="removeTenantImage" @click="removeTenantImage">Delete</p>
                                <div class="invalid-feedback custom-required-logo d-inline-block"></div>
                                <div style="margin-top: 0.25rem"
                                     class="text-danger"
                                     v-if="messErrorImage"
                                >
                                    {{ messErrorImage }}
                                </div>
                            </Field>
                        </div>
                    </div>
                </div>
                <div class="description-tenant col-md-12 d-flex">
                    <div class="col-md-6 news-form__input">
                        <label :class="errors.DescriptionEN ? 'news-form__title--error' : ''"
                               class="news-form__title label-field">
                            Input TENANT DESCRIPTION-EN
                        </label>
                        <a-textarea @change="edited = true" :status="errors.DescriptionEN ? 'error' : ''"
                                    v-model:value="infoTenant.description_en" :rows="6"/>
                        <Field name="DescriptionEN" type="hidden" class="form-control"
                               :class="{ 'is-invalid': errors.DescriptionEN }"
                               v-model="infoTenant.description_en"
                        />
                        <div class="invalid-feedback">{{ errors.DescriptionEN }}</div>
                        <div class="d-flex col-md-12 justify-content-between">
                            <div class="col-md-2 hashtag" v-for="(hashtag, index) in listHashtag">
                                <label class="news-form__hashtag">
                                    HASHTAG # {{ index + 1 }}
                                </label>
                                <a-input :maxlength="255" @keydown.enter.prevent @change="edited = true" v-model:value="hashtag.hash_tag"/>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 desc-vn news-form__input">
                        <label :class="errors.DescriptionVN ? 'news-form__title--error' : ''"
                               class="news-form__title label-field">
                            Input TENANT DESCRIPTION-VN
                        </label>
                        <a-textarea @change="edited = true" :status="errors.DescriptionVN ? 'error' : ''"
                                    v-model:value="infoTenant.description_vn" :rows="6"/>
                        <Field name="DescriptionVN" type="hidden" class="form-control"
                               :class="{ 'is-invalid': errors.DescriptionVN }"
                               v-model="infoTenant.description_vn"
                        />
                        <div class="invalid-feedback">{{ errors.DescriptionVN }}</div>
                        <div class="d-flex col-md-12 justify-content-between">
                            <div class="col-md-2 hashtag" v-for="(hashtag, index) in listHashtag">
                                <label class="news-form__hashtag">
                                    HASHTAG # {{ index + 1 }}
                                </label>
                                <a-input :maxlength="255" @keydown.enter.prevent @change="edited = true" v-model:value="hashtag.hash_tag_vn"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="collection col-md-12 mt-4">
                    <div class="info-collection">
                        <div class="d-flex collect-name">
                            <div class="col-md-6 news-form__input">
                                <label class="news-form__title label-field">
                                    COLLECTION NAME EN
                                </label>
                                <a-input :maxlength="255" :disabled="disabled" @keydown.enter.prevent @change="edited = true" v-model:value="infoTenant.tenant_collection.name"/>
                            </div>
                            <div class="col-md-6 desc-vn news-form__input">
                                <label class="news-form__title label-field">
                                    COLLECTION NAME VN
                                </label>
                                <a-input :maxlength="255" :disabled="disabled" @keydown.enter.prevent @change="edited = true" v-model:value="infoTenant.tenant_collection.name_vn"/>
                            </div>
                        </div>
                        <div class="d-flex collect-desc">
                            <div class="col-md-6 desc-vn news-form__input">
                                <label class="news-form__title label-field">
                                    COLLECTION DESCRIPTION EN
                                </label>
                                <a-textarea :disabled="disabled" @change="edited = true" v-model:value="infoTenant.tenant_collection.description" :rows="4"/>
                            </div>
                            <div class="col-md-6 desc-vn news-form__input">
                                <label class="news-form__title label-field">
                                    COLLECTION DESCRIPTION VN
                                </label>
                                <a-textarea :disabled="disabled" @change="edited = true" v-model:value="infoTenant.tenant_collection.description_vn" :rows="4"/>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="collection-image col-md-12 mt-4">
                    <div class="text-center">
                        <img src="/images/icons/button-upload-image.svg" @click="$refs.collectionImage.click()">
                        <input accept="image/jpg, image/jpeg, image/png, image/svg+xml" name="collectionImage"
                               multiple type="file" ref="collectionImage" class="d-none"
                               @change="uploadCollectionImage"
                        />
                    </div>
                    <div class="text-center d-flex custom-margin-top">
                        <div v-if="infoTenant.tenant_collection.collection_image && !isUploadCollectionImage"
                             v-for="(item, index) in infoTenant.tenant_collection.collection_image" :key="index">
                            <img class="list-image-collection" :src="'/storage/' + item.image">
                            <p class="removeImageCollection" @click="removeCollectionImage($event, index, item)">
                                Delete</p>
                        </div>
                        <div v-if="isUploadCollectionImage" v-for="(image, index) in listShowCollectionUpload"
                             :key="index">
                            <img class="list-image-collection" :src="image">
                            <p class="removeImageCollection" @click="removeCollectionImage($event, index, image)">
                                Delete</p>
                        </div>
                    </div>
                    <div
                        class="text-danger input-group"
                        role="alert"
                        v-if="messErrorCollectionImage"
                    >
                        {{ messErrorCollectionImage }}
                    </div>
                </div>
                <div>
                    <button ref="updateTenant" type="submit" class="d-none">Submit</button>
                    <button type="reset" class="btn btn-secondary d-none">Reset</button>
                </div>
            </Form>
            <a-modal :closable="false" :footer="null" v-model:open="open" :bodyStyle="{ height: '80px'}"
                     @cancel="onCancel">
                <div class="position-relative">
                    <p style="color: red">{{ messErrorTenantLogo }}</p>
                    <p style="color: red">{{ messErrorImage }}</p>
                    <button @click="onOk" style="right: 0" type="button" class="btn btn-primary position-absolute">Ok
                    </button>
                </div>
            </a-modal>
            <a-modal v-model:open="deleteConfirmShow" :closable="false" :footer="null" class="news-form__delete-modal"
                     width="275px">
                <div class="news-form__delete-confirm">
                    <div class="news-form__delete-confirm-title">Delete Tenant?</div>
                    <div class="news-form__delete-confirm-btn-group">
                        <button class="btn btn-danger" type="button" @click="deleteConfirmShow = false">
                            Cancel
                        </button>
                        <button class="btn btn-success" type="button" @click="onDelete($event, tenant.id, infoTenant.tenant_collection.id)">
                            Continue
                        </button>
                    </div>
                </div>
            </a-modal>
        </div>
    </div>
</template>

<script>
import SideNavSelect from "../reusable/SideNavSelect.vue";
import {
    LS_POINT,
    NOT_LS_POINT,
    MAX_SIZE_IMAGE_TENANT_UPLOAD,
    REMOVE_IMAGE,
    MAX_UPLOAD_ALL_COLLECTION,
    NOT_REMOVE_IMAGE,
    MAX_HASH_TAG
} from "../../const";
import {Form, Field, ErrorMessage} from 'vee-validate';
import * as yup from 'yup';
import {useToast} from "vue-toastification";
import CustomUploadTenant from "../reusable/CustomUploadTenant.vue";
import CustomUpload from "../reusable/CustomUpload.vue";

const filterOption = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
const filterOptionCategory = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
const filterOptionFloor = (input, option) => {
    return option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};

export default {
    name: 'TenantMainContent',
    setup() {
        const toast = useToast();
        return {toast}
    },
    components: {
        CustomUpload,
        CustomUploadTenant,
        SideNavSelect,
        Form, Field, ErrorMessage,
    },
    props: ['selected', 'listSection', 'tenant'],
    created() {
        this.getListFloor()
        this.infoTenant = this.tenant
        this.base64Logo = this.tenant.tenant_logo
        this.base64Image = this.tenant.tenant_image
        this.disabled = false
        this.getListCategory(this.infoTenant.section_id)
        this.infoTenant.tenant_floor.forEach((item) => {
            this.listFloorSelected.push(item.id)
        })

        this.checkLsPoint(this.infoTenant.ls_point)
        this.checkLotteVoucher(this.infoTenant.lotte_voucher)

        if (Object.keys(this.infoTenant.tenant_tag).length !== 0) {
            this.listHashtag = this.infoTenant.tenant_tag
            if (Object.keys(this.listHashtag).length < MAX_HASH_TAG) {
                let needHashTags = MAX_HASH_TAG - Object.keys(this.listHashtag).length;
                for (let i = 0; i < needHashTags; i++) {
                    this.listHashtag.push({hash_tag_vn: '', hash_tag: ''})
                }
            }
        }

        if (this.infoTenant.section_name == 'F&B') {
            this.disabled = true
        }
    },
    data() {
        const schema = yup.object({
            Name: yup.string().required(),
            Category: yup.string().required(),
            DescriptionEN: yup.string().required(),
            DescriptionVN: yup.string().required(),
            TenantLogo: yup.string().required(),
        });
        return {
            schema,
            selectSection: '',
            listFloor: [],
            listCategory: [],
            filterOption,
            filterOptionCategory,
            filterOptionFloor,
            LS_POINT,
            NOT_LS_POINT,
            MAX_SIZE_IMAGE_TENANT_UPLOAD,
            REMOVE_IMAGE,
            NOT_REMOVE_IMAGE,
            MAX_UPLOAD_ALL_COLLECTION,
            MAX_HASH_TAG,
            infoTenant: {
                name: '',
                hot_line: '',
                section_id: undefined,
                section_name: '',
                category_id: undefined,
                category_name: '',
                floor_id: [],
                tenant_logo: null,
                tenant_image: null,
                description_vn: '',
                description_en: '',
                collection_name: '',
                collection_name_vn: '',
                collection_description: '',
                collection_description_vn: '',
            },
            lsPointChecked: false,
            lotteVoucher:false,
            isShowMessageCollectionImage: false,
            messErrorCollectionImage: '',
            isUploadCollectionImage: false,
            listRemoveImageCollection: [],
            listShowCollectionUpload: [],
            listFileCollectionUpload: [],
            isRemoveCollectionImage: '',
            listHashtag: [
                {hash_tag_vn: '', hash_tag: ''},
                {hash_tag_vn: '', hash_tag: ''},
                {hash_tag_vn: '', hash_tag: ''},
                {hash_tag_vn: '', hash_tag: ''},
                {hash_tag_vn: '', hash_tag: ''}
            ],
            uploadTenantImage: true,
            messErrorImage: "",
            messErrorTenantLogo: "",
            uploadTenantImageLogo: true,
            isChangeTenantImageLogo: false,
            isChangeTenantImage: false,
            base64Logo: null,
            base64Image: null,
            open: false,
            listFloorSelected: [],
            errorFloor: false,
            errorFloorMessage: '',
            isUpdateTenant: false,
            edited: false,
            fullPage: true,
            deleteConfirmShow: false,
            isRemoveTenantImage: false,
            disabled: false
        }
    },
    methods: {
        checkLsPoint(lsPoint) {
            this.lsPointChecked = false

            if (lsPoint == LS_POINT) {
                this.lsPointChecked = true
            }
        },

      checkLotteVoucher(lotteVoucher) {
        this.lotteVoucher = false;

        if (lotteVoucher == 1) {
          this.lotteVoucher = true
        }
      },

        handleChangeSection(value, item) {
            this.tenant.section_name = item.label
            this.infoTenant.category_id = undefined
            this.getListCategory(value)
            this.edited = true

            if (item.label == 'F&B') {
                this.disabled = true
            }
        },
        handleChangeCategory(value, item) {
            this.tenant.category_name = item.label
            this.edited = true
        },
        handleChangeFloor(value) {
            this.edited = true
            if (value.length == 0) {
                this.errorFloor = true
                this.errorFloorMessage = 'Floor is a field required'
            } else {
                this.listFloorSelected = value
                this.errorFloor = false
                this.errorFloorMessage = ''
            }
        },
        getListFloor() {
            let app = this;
            axios.get('/admin/floors/getListFloor').then(response => {
                app.listFloor = response.data
            });
        },
        getListCategory(section_id) {
            let app = this;
            let params = {
                section_id: section_id
            }
            axios.get('/admin/categories/getListCategory', {params: params}).then(response => {
                app.listCategory = response.data.slice(1)
            });
        },
        saveTenant() {
            if (this.listFloorSelected.length == 0) {
                this.errorFloor = true
                this.errorFloorMessage = 'Floor is a field required'
            }

            this.$refs.updateTenant.click();
        },
        updateTenant() {
            let data = new FormData();
            var that = this
            let infoTenant = this.infoTenant
            infoTenant.listFileCollectionUpload = this.listFileCollectionUpload
            infoTenant.isRemoveCollectionImage = this.isRemoveCollectionImage
            this.infoTenant.floor_id = this.listFloorSelected
            infoTenant["listFileCollectionUpload"].forEach(item => {
                data.append("listFileCollectionUpload" + "[]", item)
            })
            infoTenant.listHashtag = this.listHashtag

            for (let key in infoTenant) {
                if (typeof infoTenant[key] === "object") {
                    if (Array.isArray(infoTenant[key])) {
                        infoTenant[key].forEach(item => {
                            data.append(key + "[]", JSON.stringify(item))
                        })
                    } else {
                        data.append(key, JSON.stringify(infoTenant[key]))
                    }
                } else {
                    data.append(key, infoTenant[key]);
                }
            }

            data.append("_method", "PUT");
            data.append("isUploadCollectionImage", this.isUploadCollectionImage);
            data.append("listRemoveImageCollection", this.listRemoveImageCollection);
            data.append("imageUpload", infoTenant.tenant_image ? infoTenant.tenant_image : '');
            data.append("tenantLogoUpload", infoTenant.tenant_logo);
            data.append("lsPointChecked", this.lsPointChecked);
            data.append("lotteVoucher", this.lotteVoucher);
            data.append("isRemoveTenantImage", this.isRemoveTenantImage);

            if (!this.messErrorImage && !this.messErrorTenantLogo && !this.errorFloor) {
                let loader = this.$loading.show({
                    // Optional parameters
                    container: this.fullPage ? null : this.$refs.formContainer,

                });
                axios.post('/admin/tenants/update', data).then(response => {
                    if (response.data.result) {
                        loader.hide();
                        that.toast.success('Update Tenant Successfully', {
                            position: "top-right",
                            timeout: 3000,
                            closeOnClick: true,
                            pauseOnFocusLoss: true,
                            pauseOnHover: true,
                            draggable: true,
                            draggablePercent: 0.6,
                            showCloseButtonOnHover: false,
                            hideProgressBar: true,
                            closeButton: "button",
                            icon: true,
                            rtl: false
                        });
                        that.isUploadCollectionImage = false
                        that.isShowMessageCollectionImage = false
                        that.messErrorCollectionImage = ''
                        that.tenant.tenant_image = response.data.tenant.tenant_image
                        that.tenant.tenant_logo = response.data.tenant.tenant_logo
                        that.tenant.tenant_floor = response.data.listSelectedFloor
                        that.infoTenant.tenant_collection.collection_image = response.data.listCollectionImage.collection_image
                        that.isUpdateTenant = true
                        that.edited = false
                        that.emitter.emit("updateTenant", that.isUpdateTenant);
                    }
                }).catch((error) => {
                    that.toast.error("An error has occurred!", {
                        position: "top-right",
                        timeout: 3000,
                        closeOnClick: true,
                        pauseOnFocusLoss: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 0.6,
                        showCloseButtonOnHover: false,
                        hideProgressBar: true,
                        closeButton: "button",
                        icon: true,
                        rtl: false
                    });
                });
            }
        },
        undo(tenantId) {
            let that = this
            axios.get('/admin/tenants/detail/' + tenantId).then(response => {
                if (response.data.result) {
                    that.disabled = false
                    that.infoTenant = response.data.tenant
                    that.tenant.section_name = that.infoTenant.section_name
                    that.listCategory = that.getListCategory(that.infoTenant.section_id)
                    that.tenant.name = that.infoTenant.name
                    that.tenant.category_name = that.infoTenant.category_name
                    that.isUploadCollectionImage = false
                    that.listFileCollectionUpload = []
                    that.listRemoveImageCollection = []
                    that.isRemoveCollectionImage = NOT_REMOVE_IMAGE
                    that.isChangeTenantImageLogo = false
                    that.base64Logo = that.infoTenant.tenant_logo
                    that.isChangeTenantImage = false
                    that.base64Image = that.infoTenant.tenant_image
                    that.checkLsPoint(that.infoTenant.ls_point)
                    that.checkLotteVoucher(that.infoTenant.lotte_voucher)
                    that.tenant.ls_point = that.infoTenant.ls_point
                    that.tenant.lotte_voucher = that.infoTenant.lotte_voucher
                    that.listFloorSelected = []
                    that.edited = false
                    that.isShowMessageCollectionImage = false
                    that.messErrorCollectionImage = ''
                    that.infoTenant.tenant_floor.forEach((item) => {
                        that.listFloorSelected.push(item.id)
                    })
                    that.tenant.tenant_collection.collection_image = that.infoTenant.tenant_collection.collection_image

                    if (Object.keys(that.infoTenant.tenant_tag).length !== 0) {
                        that.listHashtag = that.infoTenant.tenant_tag
                        if (Object.keys(that.listHashtag).length < MAX_HASH_TAG) {
                            let needHashTags = MAX_HASH_TAG - Object.keys(that.listHashtag).length;
                            for (let i = 0; i < needHashTags; i++) {
                                that.listHashtag.push({hash_tag_vn: '', hash_tag: ''})
                            }
                        }
                    }

                    if (that.infoTenant.section_name == 'F&B') {
                        that.disabled = true
                    }
                }
            }).catch((error) => {
                that.toast.error("An error has occurred!", {
                    position: "top-right",
                    timeout: 3000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: "button",
                    icon: true,
                    rtl: false
                });
            });
            this.infoTenant = this.tenant
        },
        async onDelete(e, tenantId, collectionId) {
            let that = this
            await axios.delete('/admin/tenants/delete', {
                data: {
                    tenantId: tenantId,
                    collectionId: collectionId
                }
            }).then(response => {
                if (response.data.result) {
                    that.emitter.emit("deleteTenant", tenantId);
                    that.deleteConfirmShow = false;
                    that.toast.success('Delete Successfully', {
                        position: "top-right",
                        timeout: 3000,
                        closeOnClick: true,
                        pauseOnFocusLoss: true,
                        pauseOnHover: true,
                        draggable: true,
                        draggablePercent: 0.6,
                        showCloseButtonOnHover: false,
                        hideProgressBar: true,
                        closeButton: "button",
                        icon: true,
                        rtl: false
                    });
                }
            }).catch((error) => {
                that.toast.error("An error has occurred!", {
                    position: "top-right",
                    timeout: 3000,
                    closeOnClick: true,
                    pauseOnFocusLoss: true,
                    pauseOnHover: true,
                    draggable: true,
                    draggablePercent: 0.6,
                    showCloseButtonOnHover: false,
                    hideProgressBar: true,
                    closeButton: "button",
                    icon: true,
                    rtl: false
                });
            });
        },
        uploadCollectionImage(e) {
            this.edited = true
            let files = e.target.files;
            this.listShowCollectionUpload = [];
            this.listFileCollectionUpload = []
            let result = this.checkCollectionUpload(files);

            if (!result) {
                this.isUploadCollectionImage = true
                this.isRemoveCollectionImage = NOT_REMOVE_IMAGE
            }
        },
        removeCollectionImage(e, index, item) {
            this.edited = true
            this.isRemoveCollectionImage = REMOVE_IMAGE

            if (this.isUploadCollectionImage) {
                this.listFileCollectionUpload.splice(index, 1)
                this.listShowCollectionUpload.splice(index, 1)
            } else {
                this.infoTenant.tenant_collection.collection_image.splice(index, 1)
                this.listRemoveImageCollection.push(item.id)
            }
        },

        checkCollectionUpload(images) {
            var totalFileSize = 0;
            var fileReg = /[\/.](jpg|jpeg|png|svg|JPEG|JPG|PNG|SVG)$/i

            if (images.length > MAX_UPLOAD_ALL_COLLECTION) {
                this.isShowMessageCollectionImage = true
                this.messErrorCollectionImage = "You have uploaded more than the specified number of photos"
            } else {
                for (let image of images) {
                    let fileName = image.name;
                    if (!fileReg.test(fileName)) {
                        this.isShowMessageCollectionImage = true
                        this.messErrorCollectionImage = "Uploaded file is not in the correct format"
                    } else {
                        totalFileSize += image.size;
                        let reader = new FileReader();
                        reader.readAsDataURL(image);
                        this.listShowCollectionUpload.push(URL.createObjectURL(image));
                        this.listFileCollectionUpload.push(image);
                        this.isShowMessageCollectionImage = false;
                        this.messErrorCollectionImage = "";
                        this.sysError = {};
                    }
                }

                if ((totalFileSize / (1024 * 1024)) > MAX_UPLOAD_ALL_COLLECTION) {
                    this.listShowCollectionUpload = [];
                    this.isShowMessageCollectionImage = true
                    this.messErrorCollectionImage = 'Maximum file upload size exceeded'
                }
            }

            return this.isShowMessageCollectionImage;
        },
        changeLsPoint(e) {
            this.edited = true
            this.tenant.ls_point = NOT_LS_POINT;

            if (e.target.checked == true) {
                this.tenant.ls_point = LS_POINT
            }
        },

        changeLotteVoucher(e){
         this.edited = true
         this.tenant.lotte_voucher = 2;

         if (e.target.checked == true) {
           this.tenant.lotte_voucher = 1
         }
        },
        onOk() {
            this.open = false

            if (this.messErrorTenantLogo) {
                this.messErrorTenantLogo = '';
            }

            if (this.messErrorImage) {
                this.messErrorImage = '';
            }
        },
        onCancel() {
            if (this.messErrorTenantLogo) {
                this.messErrorTenantLogo = '';
            }

            if (this.messErrorImage) {
                this.messErrorImage = '';
            }
        },
        changeUploadImage() {
            this.edited = true
            this.isRemoveTenantImage = false
        },
        removeTenantImage() {
            this.isRemoveTenantImage = true
            this.base64Image = null
            this.infoTenant.tenant_image = ''
            this.edited = true
        }
    },
    watch: {
        edited: function (val) {
            this.emitter.emit("modeUpdate", val);
        },
    }
};
</script>
